import { Routes } from '@angular/router';
import { Layout } from './layout/layout';
import { UserList } from './pages/user/user-list';
import { Dashboard } from './pages/dashboard/dashboard';
import { CallbackComponent } from './components/callback-component/callback-component';
import { Login } from './components/login/login';
import { UserDetail } from './pages/user/user-detail/user-detail';
import { UserResolver } from './resolver/user.resolver';
import { authGuard } from './core/guards/auth.guard';
import { AppRegistration } from './pages/app-registration/app-registration';
import { ClientDetail } from './pages/app-registration/client-detail/client-detail';
import { ClientResolver } from './resolver/client.resolver';
import { CorsConfig } from './pages/cors/cors-config';
import { ApplicationComponent } from './pages/applications/application.component';
import { AuditLogs } from './pages/audit-logs/audit-logs';
import { ApiCatalogueComponent } from './pages/api-catalogue/api-catalogue.component';
import { ApiGroupsComponent } from './pages/api-groups/api-groups.component';
import { TokensSessionsComponent } from './pages/tokens-sessions/tokens-sessions.component';
import { IdentityGroupsComponent } from './pages/identity-groups/identity-groups.component';
import { AccessPoliciesComponent } from './pages/access-policies/access-policies.component';

export const routes: Routes = [
  {
    path: 'callback',
    component: CallbackComponent,
  },
  {
    path: 'login',
    component: Login,
  },
  {
    path: '',
    component: Layout,

    canActivateChild: [authGuard],
    data: {
      sidebar: {
        items: [
          {
            label: 'Home',
            children: [
              {
                label: 'Dashboard',
                link: '/dashboard',
                icon: 'pi pi-home',
                section: 'Overview',
              },
              {
                label: 'Users Management',
                link: '/users',
                icon: 'pi pi-users',
                section: 'Identity security',
              },
              {
                label: 'App Registrations',
                link: '/app-registration',
                icon: 'pi pi-id-card',
              },
              {
                label: 'Cors Config',
                link: '/cors-config',
                icon: 'pi pi-shield',
              },
              {
                label: 'Applications',
                link: '/application',
                icon: 'pi pi-th-large',
              },
              {
                label: 'User Groups',
                link: '/identity-groups',
                icon: 'pi pi-bullseye',
              },
              {
                label: 'Access Policies',
                link: '/access-policies',
                icon: 'pi pi-key',
              },
              {
                label: 'Tokens & Sessions',
                link: '/tokens-sessions',
                icon: 'pi pi-ticket',
              },
              {
                label: 'API Catalogue',
                link: '/api-catalogue',
                icon: 'pi pi-arrow-right-arrow-left',
                section: 'API Management',
              },
              {
                label: 'API Groups',
                link: '/api-groups',
                icon: 'pi pi-table',
              },
              {
                label: 'Audit Logs',
                link: '/audit-logs',
                icon: 'pi pi-bars',
                section: 'Operations',
              },
            ],
          },
        ],
        settingsItems: [],
      },
    },
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        title: 'Dashboard',
        component: Dashboard,
        data: { breadcrumb: 'Dashboard' },
      },
      {
        path: 'users',
        data: { breadcrumb: 'Users' },
        children: [
          {
            path: '',
            component: UserList,
          },
          {
            path: ':id',
            component: UserDetail,
            resolve: { user: UserResolver },
            data: {
              breadcrumb: (data: any) => data.user.name,
            },
          },
        ],
      },
      {
        path: 'app-registration',
        data: { breadcrumb: 'App Registration' },
        children: [
          {
            path: '',
            component: AppRegistration,
          },
          {
            path: ':id',
            component: ClientDetail,
            resolve: { client: ClientResolver },
            data: {
              breadcrumb: (data: any) => data.client?.clientId || 'Detail',
            },
          },
        ],
      },
      {
        path: 'cors-config',
        title: 'Cors Config',
        component: CorsConfig,
        data: { breadcrumb: 'Cors Config' },
      },
      {
        path: 'application',
        title: 'Applications',
        component: ApplicationComponent,
        data: { breadcrumb: 'Applications' },
      },
      {
        path: 'api-catalogue',
        title: 'API Catalogue',
        component: ApiCatalogueComponent,
        data: { breadcrumb: 'API Catalogue' },
      },
      {
        path: 'api-groups',
        title: 'API Groups',
        component: ApiGroupsComponent,
        data: { breadcrumb: 'API Groups' },
      },
      {
        path: 'audit-logs',
        title: 'Audit Logs',
        component: AuditLogs,
        data: { breadcrumb: 'Audit Logs' },
      },
      {
        path: 'identity-groups',
        title: 'User Groups',
        component: IdentityGroupsComponent,
        data: { breadcrumb: 'User Groups' },
      },
      {
        path: 'access-policies',
        title: 'Access Policies',
        component: AccessPoliciesComponent,
        data: { breadcrumb: 'Access Policies' },
      },
      {
        path: 'tokens-sessions',
        title: 'Tokens & Sessions',
        component: TokensSessionsComponent,
        data: { breadcrumb: 'Tokens & Sessions' },
      },
    ],
  },
];
